// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"ff12734a","686":"2c052c7d","886":"390bf96c","997":"cbe585dc"}[chunkId] + ".chunk.css";
};